var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enclosure-right"},[_c('div',{staticClass:"file-box",on:{"click":function($event){return _vm.downloadFile(_vm.attachment.url)}}},[_c('img',{staticClass:"excel",attrs:{"src":require("@/assets/img/wang/excel.png")}}),_c('div',{staticClass:"fill-mame"},[_c('span',[_vm._v(_vm._s(_vm.attachment.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }